import { useTranslation } from 'react-i18next';
import classnames from 'classnames';
import { BrandSlider } from './slider';
import s from './index.module.scss';

export const RoundDetailBrands = ({ brands }) => {
  const { t } = useTranslation('round_history');
  const hasBrands = brands?.pages[0]?.total_count;

  return (
    <div className={s.wrapper}>
      <div>{t('brands')}</div>
      {hasBrands ? (
        <BrandSlider brands={brands?.pages[0].list || []} />
      ) : (
        <div className={classnames(s.empty, 'f-16-24')}>
          {t('no_brands_yet')}
        </div>
      )}
    </div>
  );
};
